// src/chatbot/LisasInterview.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// Default context for this whole question set
const interviewContext =
  "You are a thoughtful and respectful interviewer helping someone who is overwhelmed with the amount of tidying and sorting to do in their house. They have already asked for professional organisational help so this is an interview for that professional to get a better idea of the task ahead and the person's feelings around the space they live in. Ask emotionally intelligent, insightful follow-ups based only on the last answer. If no follow-up is needed, respond exactly with 'NO_FOLLOW_UP'.";

const questions = [
{
    text: "This is a practice question to get used to the Fireside Chatbot. If you've used it before, just press Skip. Could you describe your day yesterday? ",
    followups: 2,
	placeholder: "You could talk about what you did, what you ate, what you watched or read...",
    // optional per-question context override (only for this question’s follow-ups)
    context:
      "This is just a practice question for them to get used to talking to the chatbot so just ask an informed follow-up question based on their response."
  },
  {
    text: "This is your first real question. Please go to the room you want to focus on sorting. Can you describe everything that you can see in the room in as much detail as possible?",
    followups: 2,
    // optional
    placeholder: "You could talk about the boxes and what is in them. The furniture. The things in piles..."
  },
  {
    text: "Can you describe what you would like this room to look like? Think big and don't limit yourself, pretend that time, money and effort are no object",
    followups: 1,
    // optional per-question context override (only for this question’s follow-ups)
    //context:
      //"Be a precise debriefer. Ask short, practical follow-ups to clarify dates, locations, units, ships, and objectives. If no follow-up is needed, respond exactly with //'NO_FOLLOW_UP'."
  },
  { text: "Could you talk about what you've done in the past to try and sort this room out? If you have never tried, just skip this question", followups: 0 },
  { text: "What do you think has stopped you from making the progress you'd have liked to with this room?", followups: 2 },
    { text: "This is your final question, is there anything else you'd like to add?", followups: 0 }
];

export default function LisasInterview() {
  return (
    <ChatbotCore
      title="Lisa's Interview"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}
